import { createFileRoute } from '@tanstack/react-router';
import { BroadcastTestRouteView } from '@/pages/workspaces/broadcasts/broadcast/routing';

function BroadcastTestRoute() {
  const { broadcastId, actionId } = Route.useParams();
  return <BroadcastTestRouteView broadcastId={broadcastId} actionId={actionId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/tests/$actionId',
)({
  component: BroadcastTestRoute,
});
